'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _listing = require('./components/listing');

var _listing2 = _interopRequireDefault(_listing);

var _view = require('./components/view');

var _view2 = _interopRequireDefault(_view);

var _order = require('./components/order.config');

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _order2 = require('./services/order.service');

var _order3 = _interopRequireDefault(_order2);

var _orderDataprovider = require('./services/order.dataprovider.service');

var _orderDataprovider2 = _interopRequireDefault(_orderDataprovider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('orders', [_angularUiRouter2.default]).component('ordersListing', _listing2.default).component('orderView', _view2.default).service('Orders', _order3.default).service('OrdersDataProvider', _orderDataprovider2.default).config(_order.OrderConfig).name;

// WEBPACK FOOTER //


/** WEBPACK FOOTER **
 ** ./client/app/modules/orders/index.js
 **/